'use strict';

var $ = require('jquery');
var Backbone = require('backbone');
var _ = require('underscore');
var historyModel = require('components/consumerweb-client-error-logger/historyModel');
var overpanelView = require('widgets/theoverpanel');
var wurfl = require('lib/wurfl');
require('backboneSubroute');
require('lib/webpack-setup'); // needed for the require.ensure stuff to work

module.exports = Backbone.SubRoute.extend({

	view: {}, /* Holds reference to current view loaded */

	_savedViews: {},

	/**
	 * Handles default view use cases
	 * @param {Object} options An object containing:
	 * @param {String} options.name The action being passed to the route from the URI
	 * @param {Object} options.args The arguments being passed to the view upon initialization
	 * @param {Boolean} options.afterRender Apply the afterRender function after loading the view
	 * @param {Function} options.callback Function to execute after scripts are loaded
	 */
	showView: function (options) {
		// query string 'param1=val1&param2=val2' is populated in `options` arg in the latest Backbone (> ver 1.1.0)
		// So ignore argument if type of `options` is not `object`
		if (!_.isObject(options)) {
			options = {};
		}
		options.name = options.name || $('body').data('view-name');

		if (options.name) {
			this.loadScripts(options);
		}

		historyModel.addPath(options.name);
	},

	getPath: function (scriptName) {
		var scriptNameParts;

		if (wurfl.isWireless) {
			scriptNameParts = scriptName.split('/');
			return [scriptNameParts[0], 'phone', scriptNameParts.slice(1)].join('/');
		}

		return scriptName;
	},

	/**
	 * Handles default view use cases
	 * @param {Object} options An object containing:
	 * @param {String} options.name The action being passed to the route from the URI
	 * @param {Object} options.args The arguments being passed to the view upon initialization
	 * @param {Boolean} options.afterRender Apply the afterRender function after loading the view
	 * @param {Function} options.callback Function to execute after scripts are loaded
	 */
	loadScripts: function (options) {

		var name = options.name,
			args = options.args,
			callback = options.callback,
			// afterRender could be false
			afterRender = typeof options.afterRender !== 'undefined' ? options.afterRender : true,
			path = this.getPath(name);

		// HACK: getPath adds "/phone/" for all script requests
		// on mobile devices (which breaks non-settings flows on mobile)
		path = name;

		// avoid duplicate loading
		if (this._savedViews[path]) {
			this.view = this._savedViews[path];
			if (callback) {
				return callback(this.view);
			}
			return this.view;
		}

		var loadView = function(View) {
			this.view = new View(args);
			this._savedViews[path] = this.view;
			this.view.delegateEvents();
			if (afterRender) {
				this.view.afterRender();
			}
			if (callback) {
				callback(this.view);
				return;
			}
		}.bind(this);

		/* !! WEBPACK BUNDLING MAGIC HAPPENS HERE !!
		 * SEE: http://webpack.github.io/docs/code-splitting.html
		 *
		 * Note: Some pages (Activity-Beta, Transaction Details) do not have an
		 * "index view" and page components are initialized in their subroute,
		 * so their magic happens in pub/js/router */
		if (path.indexOf('wallet') > -1) {
			require(['view/wallet'], loadView);
		} else if (path.indexOf('summary') > -1) {
			require(['view/summary'], loadView);
		} else if (path.indexOf('payment') > -1) {
			require(['view/payment'], loadView);
		} // else {
			// TODO: use this if many pages are missing JS
			// and you don't feel like manually adding them
			// the above list...just know file size is huge
			// and it slows down the build time
			// require(['view/' + path], loadView);
		// }
	},

	/**
	 * Handling page cleanup of widgets from previous views
	 * Subroute should handle the cleaning of the view
	 */
	cleanView: function () {
		// close overpanel if it exists
		if (overpanelView.exists()) {
			overpanelView.hideOverpanel();
		}
		// close modal if it exists
		var $openModal = $('.openModal');
		if ($openModal) {
			$openModal.modal('hide');
		}
	}
});



//////////////////
// WEBPACK FOOTER
// ./routes/helper.js
// module id = 20
// module chunks = 0